import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new BehaviorSubject<{ message: string; type: 'success' | 'error' | 'warning'; showToast: boolean }>({
    message: '',
    type: 'success',
    showToast: false,
  });

  toast$ = this.toastSubject.asObservable();

  showToast(message: string, type: 'success' | 'error' | 'warning') {
    this.toastSubject.next({ message, type, showToast: true });
    setTimeout(() => this.hideToast(), 5000);
  }

  hideToast() {
    this.toastSubject.next({ ...this.toastSubject.value, showToast: false });
  }
}
